// src/FacebookIcon.tsx
import { jsx } from "react/jsx-runtime";
var FacebookIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M0.447266 10.0856C0.448436 15.0352 4.0477 19.2497 8.93621 20.0254V12.9934H6.38359V10.0856H8.93923V7.87203C8.82498 6.82315 9.18324 5.77781 9.91685 5.01951C10.6505 4.26121 11.6834 3.86854 12.7355 3.94802C13.4906 3.96021 14.2439 4.02747 14.9892 4.14925V6.62339H13.7175C13.2796 6.56604 12.8394 6.71064 12.5209 7.01646C12.2024 7.32228 12.04 7.7562 12.0794 8.19601V10.0856H14.8675L14.4218 12.9944H12.0794V20.0254C17.3663 19.1899 21.0736 14.3615 20.5156 9.03824C19.9576 3.71496 15.3296 -0.239676 9.98444 0.0392804C4.63928 0.318237 0.448115 4.73313 0.447266 10.0856Z" })
  }
);
var FacebookIcon_default = FacebookIcon;

export {
  FacebookIcon_default
};
